import { Component } from '@angular/core';

@Component({
  selector: 'app-certification-list',
  templateUrl: './certification-list.component.html',
  styleUrls: ['./certification-list.component.sass']
})
export class CertificationListComponent {

}
